import { render } from "./VolunteerDelivery.vue?vue&type=template&id=6f56cf6c&scoped=true"
import script from "./VolunteerDelivery.vue?vue&type=script&lang=js"
export * from "./VolunteerDelivery.vue?vue&type=script&lang=js"

import "./VolunteerDelivery.vue?vue&type=style&index=0&id=6f56cf6c&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6f56cf6c"]])

export default __exports__